import AbstractValidator from '../abstract-validator';
import AbstractValidatorOptions from '../abstract-validator-options';
import { initGrecaptchaV3 } from '../../../other/grecaptcha';

function CampaignOfferSendForm() {
    const validator = AbstractValidator(
        'campaignOfferSendForm',
        false,
    );
    const validatorOptions = AbstractValidatorOptions();
    const campaignContainer = $('.desktop-container');

    function init() {
        validatorOptions.focusInvalid = false;

        validator.init(
            {
                from: {
                    required: true,
                },
                from_email: {
                    required: true,
                    customEmail: true,
                },
                recipients: {
                    required: true,
                },
                subject: {
                    required: true,
                },
            },
            validatorOptions,
        );

        $('#sendModal').on(
            'hidden.bs.modal',
            () => validator.resetForm(),
        );
        if (campaignContainer.find('.recaptcha-v3').length !== 0) {
            initGrecaptchaV3(
                'campaignOfferSendForm',
                'sendmail',
            );
        }
    }

    return {
        init,
    };
}

export default CampaignOfferSendForm;
